import React from "react";
import "./style.scss";
import {
  getPredefineOptionsList,
  openLoader,
  closeLoader,
} from "../../../AdminDashboard/AdminMentorAction/dependencies/action";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Modal } from "react-bootstrap";
import {
  Avatar,
  Box,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Paper,
  Typography,
} from "@material-ui/core";
import useStyles from "./style";
import "@fontsource/montserrat";
let value = JSON.parse(localStorage.getItem("SavedLoggedInData"));

const CustomModal = (props) => {
  const classes = useStyles();

  const handleClose = () => {
    props.setModalOpen(false);
  };
  const newparticipant = props?.participants?.filter(function (item) {
    return item?.userId !== value?.id;
  });

  const withoutAdmin = newparticipant?.filter(function (item) {
    return item?.role !== "Admin";
  });

  const mentorparticipant = withoutAdmin?.filter(function (item) {
    return item?.role !== "Startup";
  });

  const startupparticipant = withoutAdmin?.filter(function (item) {
    return item?.role !== "Mentor";
  });

  const nomentoronlystartupandadmin = newparticipant?.filter(function (item) {
    return item?.role !== "Mentor";
  });

  const onlyAdmin = nomentoronlystartupandadmin?.filter(function (item) {
    return item?.role !== "Startup";
  });

  return (
    <Modal
      size="lg"
      show={props.modalOpen}
      onHide={() => props.setModalOpen(false)}
      aria-labelledby="example-modal-sizes-title-lg"
      style={{ borderRadius: "7px" }}
      // className={props.clickedGroupName === false ? "groupfalse" : "grouptrue"}
      className={"grouptrue"}
    >
      <Modal.Header className="d-flex ">
        <Modal.Title className="modalHeading d-flex justify-content-center">
          {/* {props.clickedGroupName === false
            ? "LIST OF MENTORS AND STARTUPS"
            : "LIST OF PARTICIPANTS"} */}
          LIST OF PARTICIPANTS
        </Modal.Title>
        <div className="newuserTooltip">
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={handleClose}
          />
          <span
            className="tooltiptext  close-window"
            style={{ left: "-110px", top: "2px", width: "118px" }}
          >
            Close Window
          </span>
        </div>
      </Modal.Header>
      <Modal.Body>
        <Paper elevation={0} className={classes.listContainer}>
          <>
            <Typography
              className={classes.goalLabel}
              style={{ marginBottom: "20px", fontSize: "16px" }}
            >
              {/* {props.clickedGroupName === false
                ? "List of Mentors and Startups in Group"
                : "List of Participants in Group"} */}
              List of Participants in Group
              {props.groupName}
            </Typography>
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                margin: "0",
              }}
            >
              {props.clickedGroupName != false && onlyAdmin?.length > 0 && (
                <Typography
                  className={classes.goalLabel3}
                  style={{
                    flex: 1,
                  }}
                >
                  TOTAL ADMINS: {onlyAdmin && onlyAdmin?.length}
                </Typography>
              )}
            </Box>
            <Box
              className={classes.flexAcross}
              style={{
                // justifyContent:
                //   props.clickedGroupName === false ? "space-between" : "center",
                justifyContent: "space-between",
              }}
            >
              <Box className={classes.flexAcrossWidth}>
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    margin: "0",
                  }}
                >
                  {/* {props.clickedGroupName === false ? (
                    <Typography
                      className={classes.goalLabel3}
                      style={{
                        flex: 1,
                      }}
                    >
                      TOTAL MENTORS: {props?.mentorNamesList?.length}
                    </Typography>
                  ) : ( */}
                  <Typography
                    className={classes.goalLabel3}
                    style={{ flex: 1 }}
                  >
                    TOTAL MENTORS: {mentorparticipant?.length}
                  </Typography>
                  {/* )} */}
                  {/* <Typography
                    className={classes.goalLabel3}
                    style={{ flex: 1 }}
                  >
                    TOTAL STARTUP: {startupparticipant?.length}
                  </Typography> */}
                </Box>
                <Box className={classes.listOverflow}>
                  {/* {props.clickedGroupName === false ? (
                    <List className={classes.list}>
                      {props?.mentorNamesList?.map((datum, index) => (
                        <>
                          <ListItem alignItems="center">
                            <ListItemAvatar>
                              <Avatar
                                classes={{
                                  img: classes.objectFit,
                                }}
                                src={datum?.image}
                              />
                            </ListItemAvatar>
                            <ListItemText
                              primary={
                                <>
                                  <Typography
                                    style={{
                                      fontFamily: "Montserrat",
                                      fontSize: "16px",
                                    }}
                                  >
                                    {datum?.name}
                                  </Typography>
                                </>
                              }
                            />
                          </ListItem>
                          <Divider variant="inset" component="li" />
                        </>
                      ))}
                    </List>
                  ) : (
                    <> */}
                  <List className={classes.list}>
                    {mentorparticipant?.map((datum, index) => (
                      <>
                        <ListItem alignItems="center">
                          <ListItemAvatar>
                            <Avatar
                              classes={{
                                img: classes.objectFit,
                              }}
                              src={datum?.image}
                            />
                          </ListItemAvatar>
                          <ListItemText
                            primary={
                              <>
                                <Typography
                                  style={{
                                    fontFamily: "Montserrat",
                                    fontSize: "16px",
                                  }}
                                >
                                  {datum?.name}
                                </Typography>
                              </>
                            }
                          />
                        </ListItem>
                        <Divider variant="inset" component="li" />
                      </>
                    ))}
                  </List>
                  {/* </>
                  )} */}
                  {/* <List className={classes.list}>
                    {props.mentorNamesList?.map((datum, index) => (
                      <>
                        <ListItem alignItems="center">
                          <ListItemAvatar>
                            <Avatar
                              classes={{
                                img: classes.objectFit,
                              }}
                              src={datum?.image}
                            />
                          </ListItemAvatar>
                          <ListItemText
                            primary={
                              <>
                                <Typography
                                  style={{
                                    fontFamily: "Montserrat",
                                    fontSize: "16px",
                                  }}
                                >
                                  {datum?.name}
                                </Typography>
                              </>
                            }
                          />
                        </ListItem>
                        <Divider variant="inset" component="li" />
                      </>
                    ))}
                  </List> */}
                </Box>
              </Box>
              <Box className={classes.flexAcrossWidth}>
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    margin: "0",
                  }}
                >
                  {/* {props.clickedGroupName === false ? (
                    <Typography
                      className={classes.goalLabel3}
                      style={{
                        flex: 1,
                      }}
                    >
                      TOTAL MENTORS: {props?.mentorNamesList?.length}
                    </Typography>
                  ) : ( */}
                  <Typography
                    className={classes.goalLabel3}
                    style={{ flex: 1 }}
                  >
                    TOTAL MENTORS: {startupparticipant?.length}
                  </Typography>
                  {/* )} */}
                  {/* <Typography
                    className={classes.goalLabel3}
                    style={{ flex: 1 }}
                  >
                    TOTAL STARTUP: {startupparticipant?.length}
                  </Typography> */}
                </Box>
                <Box className={classes.listOverflow}>
                  {/* {props.clickedGroupName === false ? (
                    <List className={classes.list}>
                      {props?.mentorNamesList?.map((datum, index) => (
                        <>
                          <ListItem alignItems="center">
                            <ListItemAvatar>
                              <Avatar
                                classes={{
                                  img: classes.objectFit,
                                }}
                                src={datum?.image}
                              />
                            </ListItemAvatar>
                            <ListItemText
                              primary={
                                <>
                                  <Typography
                                    style={{
                                      fontFamily: "Montserrat",
                                      fontSize: "16px",
                                    }}
                                  >
                                    {datum?.name}
                                  </Typography>
                                </>
                              }
                            />
                          </ListItem>
                          <Divider variant="inset" component="li" />
                        </>
                      ))}
                    </List>
                  ) : (
                    <> */}
                  <List className={classes.list}>
                    {startupparticipant?.map((datum, index) => (
                      <>
                        <ListItem alignItems="center">
                          <ListItemAvatar>
                            <Avatar
                              classes={{
                                img: classes.objectFit,
                              }}
                              src={datum?.image}
                            />
                          </ListItemAvatar>
                          <ListItemText
                            primary={
                              <>
                                <Typography
                                  style={{
                                    fontFamily: "Montserrat",
                                    fontSize: "16px",
                                  }}
                                >
                                  {datum?.name}
                                </Typography>
                              </>
                            }
                          />
                        </ListItem>
                        <Divider variant="inset" component="li" />
                      </>
                    ))}
                  </List>
                  {/* </>
                  )} */}
                  {/* <List className={classes.list}>
                    {props.mentorNamesList?.map((datum, index) => (
                      <>
                        <ListItem alignItems="center">
                          <ListItemAvatar>
                            <Avatar
                              classes={{
                                img: classes.objectFit,
                              }}
                              src={datum?.image}
                            />
                          </ListItemAvatar>
                          <ListItemText
                            primary={
                              <>
                                <Typography
                                  style={{
                                    fontFamily: "Montserrat",
                                    fontSize: "16px",
                                  }}
                                >
                                  {datum?.name}
                                </Typography>
                              </>
                            }
                          />
                        </ListItem>
                        <Divider variant="inset" component="li" />
                      </>
                    ))}
                  </List> */}
                </Box>
              </Box>
              {/* {props.clickedGroupName === false ? (
                <Box className={classes.flexAcrossWidth}>
                  <Box
                    style={{
                      display: "flex",
                      alignItems: "center",
                      margin: "0",
                    }}
                  >
                    <Typography
                      className={classes.goalLabel3}
                      style={{ flex: 1 }}
                    >
                      TOTAL STARTUPS: {props.startupNamesList?.length}
                    </Typography>
                  </Box>
                  <Box className={classes.listOverflow}>
                    <List className={classes.list}>
                      {props.startupNamesList?.map((datum, index) => (
                        <>
                          <ListItem alignItems="center">
                            <ListItemAvatar>
                              <Avatar
                                classes={{
                                  img: classes.objectFit,
                                }}
                                src={datum.image}
                              />
                            </ListItemAvatar>
                            <ListItemText
                              primary={
                                <>
                                  <Typography
                                    style={{
                                      fontFamily: "Montserrat",
                                      fontSize: "16px",
                                      paddingRight: "40px",
                                    }}
                                  >
                                    {datum?.name}
                                  </Typography>
                                </>
                              }
                            />
                          </ListItem>
                          <Divider variant="inset" component="li" />
                        </>
                      ))}
                    </List>
                  </Box>
                </Box>
              ) : (
                ""
              )} */}
            </Box>
          </>
        </Paper>
      </Modal.Body>
    </Modal>
  );
};
const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
  };
};
export default connect(mapStateToProps, {
  getPredefineOptionsList,
  openLoader,
  closeLoader,
})(withRouter(CustomModal));
